import React, { useState } from "react";
import { Textarea } from "../ui/textarea";
import Button from "./button";
import Markdown from "../markdown/Markdown";

interface MarkdownEditorProps {
    value: string;
    onChange: (text: string) => void;
    placeholder?: string;
    className?: string;
    markdownClassName?: string;
    id?: string;
}
export default function MarkdownEditor({ value, onChange, placeholder, id, className, markdownClassName }: MarkdownEditorProps) {
    const [showMarkdown, setShowMarkdown] = useState(false);

    function countCharacters(input: string): number {
        return input.length;
    }

    function countWords(input: string): number {
        const words = input.split(/\s+/).filter((word) => /^[A-Za-z]+$/.test(word));
        return words.length;
    }

    return (
        <div>
            <div className="mb-2 flex items-center justify-between gap-2">
                <div className="flex h-8 w-full items-center rounded border px-4 text-sm text-slate-500 dark:text-slate-500">
                    {countWords(value)} words — {countCharacters(value)} characters
                </div>
                <Button onClick={() => setShowMarkdown(!showMarkdown)} size={"small"}>
                    {showMarkdown ? "Hide" : "Show"}
                </Button>
            </div>

            {showMarkdown ? (
                <div className={markdownClassName || className}>
                    <Markdown>{value}</Markdown>
                </div>
            ) : (
                <Textarea id={id} className={className} value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} />
            )}
        </div>
    );
}
